var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextStrikethrough = function SvgTextStrikethrough(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M10 10c1.893 0 4.167.362 4.167 3.223 0 4.225-7.225 4.588-8.212.943M10 10h7.5M10 10H2.5m3.333-3.224c0-4.225 7.225-4.588 8.212-.943"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextStrikethrough);
export default ForwardRef;